import { UnleashClient } from 'unleash-proxy-client';

import {
  UNLEASH_APP_NAME,
  UNLEASH_CLIENT_KEY,
  UNLEASH_URL,
} from '../../api/constants';

export let unleash: UnleashClient;
let userId: string;

export async function getUnleashInstance(businessId?: string) {
  if (!unleash) {
    if (!businessId) {
      console.warn(
        'businessId not specified. Starting unleash without userId context'
      );
    }

    unleash = new UnleashClient({
      url: UNLEASH_URL!,
      clientKey: UNLEASH_CLIENT_KEY!,
      appName: UNLEASH_APP_NAME!,
      refreshInterval: 0,
      context: { userId: businessId },
    });

    userId = businessId;

    // Wait until it finishes setup
    await unleash.start();

    // Stop immediately to stop the background polling
    // https://www.npmjs.com/package/unleash-proxy-client
    // Once the client has been stopped, it will no longer check for updates or send metrics to the server.
    // A stopped client can be restarted.
    unleash.stop();
  }

  if (businessId && businessId !== userId) {
    console.warn(
      `Different businessId (new: ${businessId}, old: ${userId}) detected. Setting unleash context and restarting client.`
    );

    userId = businessId;

    // Reset context
    unleash.setContextField('userId', businessId);

    // Start polling to update the flag because of the changes
    // and immediately stop
    await unleash.start();
    unleash.stop();
  }

  return unleash;
}
